import { useFocusTrap } from '@websolutespa/bom-mixer-hooks';
import { useLlm, useLlmView } from '@websolutespa/bom-mixer-llm';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useRef } from 'react';
import { Aside } from './aside';
import { Content } from './content';
import style from './main.module.scss';

const reveal = {
  hidden: {
    opacity: 0,
    scale: .98,
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: .3,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: .3,
      delay: .3,
    },
  },
};

export const Main: React.FC = () => {
  const {
    Canvas,
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const visible = useLlmView(state => state.visible);
  const embedded = useLlmView(state => state.embedded);

  const { open } = useLlmView(state => state.actions);
  const dismissable = useLlmView(state => state.dismissable);
  const openingSound = app?.contents?.openingSound;

  const trapRef = useRef<HTMLDivElement>(null);
  // !!! do not remove
  const [trap, setTrap] = useFocusTrap(trapRef, { disabled: embedded });

  return (
    <motion.main
      key="main"
      variants={reveal}
      initial="hidden"
      animate="show"
      exit="exit"
      className={style.main}
      data-lenis-prevent
      ref={trapRef}
    >
      <div className={style.inner}>
        {visible && (
          <Canvas />
        )}
        <Aside />
        <Content />
      </div>
      {dismissable && (
        <>
          <button type="button" aria-label="Close" className={style.close} onClick={() => open()}>
            <span>Close</span> <XIcon />
          </button>
          {openingSound && (
            <audio src={openingSound.src || openingSound.url} autoPlay loop={false} />
          )}
        </>
      )}
    </motion.main>
  );
};

